import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import WidgetDisplayLogicModal from '@/components/container/modal/widget/displayLogic/WidgetDisplayLogicModal'

interface WidgetDisplayLogicModalState {}

const defaultValue = {}

export const WidgetDisplayLogicModalContext =
  createModalContext<WidgetDisplayLogicModalState>(defaultValue)

const WidgetDisplayLogicModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<WidgetDisplayLogicModalState>(defaultValue)
  return (
    <WidgetDisplayLogicModalContext.Provider value={state}>
      {children}
      <WidgetDisplayLogicModal />
    </WidgetDisplayLogicModalContext.Provider>
  )
}

export default WidgetDisplayLogicModalProvider
